import { UserInfo } from '@games/types';

export const LS_ITEM = 'user_info';

export const storeUserInfo = (info: UserInfo | null) => {
  if (info) {
    if (info.token === null) {
      localStorage.setItem(
        LS_ITEM,
        JSON.stringify({
          ...info,
        }),
      );
    } else {
      localStorage.setItem(LS_ITEM, JSON.stringify(info));
    }
  } else {
    clearUserInfo();
  }
};

export const getUserInfo = (): UserInfo | null => {
  const info = localStorage.getItem(LS_ITEM);
  if (info) {
    try {
      return JSON.parse(info);
    } catch{
      return null;
    }
  }
  return null;
};

export const clearUserInfo = () => {
  localStorage.removeItem(LS_ITEM);
};
